export default "__VITE_ASSET__CHPTzcYZ__"